import SystemValueList from "../../../../components/SystemValue/SystemValueList";

const COLUMNS = [
  { header: "Name", render: (u) => u.name || "—" },
];

const UnitList = ({ units, onEdit, onDelete }) => (
  <SystemValueList
    items={units}
    columns={COLUMNS}
    onEdit={onEdit}
    onDelete={onDelete}
    emptyMessage="No units added yet."
  />
);

export default UnitList;
